import { forwardRef } from 'react';
import { Drawer } from 'vaul';
import { ReactHooks } from '@team/react-hooks';
import { OverlayProps } from '../../types';
import css from './style.module.css';

export const Entry = forwardRef<HTMLDivElement, OverlayProps>(
  function Component({ background }, forwardedRef) {
    const style = ReactHooks.useObjectMemo({ background });

    return (
      <Drawer.Overlay className={css.root} style={style} ref={forwardedRef} />
    );
  }
);
